import { Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import AssembliesDetailView from '../../views/assemblies/aseemblies-detail.view'
import styles from "./assemblies-detail.module.css"
import { WorkflowService, LocalStorageService, AssembliesService, WorkflowMessagesService, SignatureProfileService } from '../../../services'
import { useParams } from 'react-router-dom'
import { socket } from "../../../Context";
import moment from 'moment';
import { convertToStandarDate } from '../../../utils'
import { useTranslation } from 'react-i18next'
import ManageAssemblyAction from '../manage-assembly/manage-assembly.action'

const AssembliesDetailAction = (props) => {
    const { t } = useTranslation()

    let {
        location,
        history
    } = props

    const url = process.env.REACT_APP_MIFIRMA_API;
    const workflowService = new WorkflowService(url);
    const workflowMessagesService = new WorkflowMessagesService(url);
    const signatureProfileService = new SignatureProfileService(url);
    const token = LocalStorageService.retrieveToken()
    const user = LocalStorageService.retrieveItem("user");
    const timezone = LocalStorageService.retrieveItem("timezone")
    const preferredLanguage = LocalStorageService.retrieveItem("preferredLanguage")
    const language = preferredLanguage || "es"
    moment.locale(language);
    const { workflowExecutionId } = useParams()

    const statusValidate = [
        Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316110),
        Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316130),
        Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316299),
        Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316140),
    ]
    let idAuthorMessage = 0

    const [isLoading, setIsLoading] = useState(true)
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
    const [showErrorRequesting, setShowErrorRequesting] = useState(false)
    const [messageComplete, setMessageComplete] = useState('')
    const [messageError, setMessageError] = useState('')
    const [titleHeader, setTitleHeader] = useState(t("assembliesDetailAction.title"))
    const [assembly, setAssembly] = useState(null)
    const [workflow, setWorkflow] = useState({})
    const [statusWorkflow, setStatusWorkflow] = useState(0)
    const [showBtnNextStatus, setShowBtnNextStatus] = useState(false)
    const [showBtnBackStatus, setShowBtnBackStatus] = useState(false)
    const [showBtnCancelStatus, setShowBtnCancelStatus] = useState(false)
    const [nameBtnNext, setNameBtnNext] = useState('')
    const [backBtnName, setNameBackBtn] = useState('')
    const [cancelBtnName, setCancelBtnName] = useState('')
    const [usersChat, setUsersChat] = useState({})
    const [membersChat, setMembersChat] = useState([])
    const [conversation, setConversation] = useState([])
    const [fileChat, setFileChat] = useState(null)
    const [userHasPermission, setUserHasPermission] = useState(false)
    const [showInvitations, setShowInvitations] = useState(false)
    const [showChat, setShowChat] = useState(false)
    const [showPdf, setShowPdf] = useState(false)
    const [guests, setGuests] = useState([])
    const [showBtnAddGuest, setShowBtnAddguest] = useState(false)
    const [statusCancel, setStatusCancel] = useState(null)
    const [showBtnToManageAssembly, setShowBtnToManageAssembly] = useState(false)

    useEffect(() => {
        socket.emit("leaveRoom", workflowExecutionId)
        getAssembly()
        getWorkflowExecution()
        getMessages()

        //call sockets    
        socket.on("messages", (data) => addNewMessageSocket(data));
        socket.emit("joinRoom", workflowExecutionId)
    }, [])

    const toggleLoadingRequesting = (value) => {
        setShowLoadingRequesting(value)
    };

    const toggleCompletedRequesting = (time, sendInbox, path, message) => {
        let sendTo = (path && path !== '') ? path : "/"
        setShowCompletedRequesting(true)
        setMessageComplete(message || '')
        setTimeout(() => {
            setShowCompletedRequesting(false)
            setMessageComplete('')
            if (sendInbox) {
                const locationState = location.state
                if (locationState && locationState.from) {
                    history.push({
                        pathname: locationState.from,
                        state: locationState
                    })
                } else {
                    history.push(sendTo);
                }
            }
        }, time || 4000)
    }

    const toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        setShowErrorRequesting(true)
        setMessageError(message || '')
        setTimeout(() => {
            setShowErrorRequesting(false)
            setMessageComplete('')
            if (sendInbox) {
                const locationState = location.state
                if (locationState && locationState.from) {
                    history.push({
                        pathname: locationState.from,
                        state: locationState
                    })
                } else {
                    history.push(sendTo);
                }
            }
        }, time || 4000)
    }

    const toggleErrorRequestingFalse = () => {
        setShowErrorRequesting(false)
    }

    const getAssembly = async () => {
        let errorMessage = t("assembliesDetailAction.errors.assembly")
        try {
            if (props.assemblySelected) {
                setAssembly(props.assemblySelected)
                setIsLoading(false)
            } else {
                const path = window.location.hash; // "/producto/42"
                const segments = path.split("/").filter(Boolean); // ["producto", "42"]
                const token = LocalStorageService.retrieveToken()
                const timezone = LocalStorageService.retrieveItem("timezone")
                const assembly = await AssembliesService.getAssembly(segments[2], timezone, token)
                if (assembly.statusCode === 200) {
                    let guests = (assembly.data && assembly.data.invitations) ? assembly.data.invitations : []
                    guests = guests.map(guest => {
                        let convertDate = convertToStandarDate(guest.createdDate, language)
                        guest.dateFormatted = convertDate || ''
                        guest.type = (guest.shareholderId) ? t("assembliesDetailAction.label.guest.type.shareholder") : t("assembliesDetailAction.label.guest.type.guest")
                        guest.attendanceValue = (guest.attendance) ? t("assembliesDetailAction.label.attendance.yes") : t("assembliesDetailAction.label.attendance.no")
                        guest.attendance = guest.attendance || false
                        return guest
                    })
                    setAssembly(assembly.data.assembly)
                    setGuests(guests)
                    setTimeout(() => {
                        setIsLoading(false)
                    }, [3000])
                } else {
                    throw new Error("Error")
                }
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
            toggleErrorRequesting(errorMessage, 4000, true, "/")
        }
    }

    const getWorkflowExecution = async () => {
        let errorMessage = t("assembliesDetailAction.errors.workflow")
        try {
            let workflowExecution = await workflowService.getWorkFlowExecutionById(workflowExecutionId, token);
            if (workflowExecution && workflowExecution.data && Number(workflowExecution.statusCode) === 200) {
                let statusCurrent = workflowExecution.data.workflowStatusDescriptions.statusCurrent.status;
                let currenteName = workflowExecution.data.workflowStatusDescriptions.statusCurrent.name;
                let titleHeader = `${t("assembliesDetailAction.title")} / ${currenteName || ''}`
                let statusIsEnable = statusValidate.includes(statusCurrent)
                let nameBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusNext && workflowExecution.data.workflowStatusDescriptions.statusNext.name) ? workflowExecution.data.workflowStatusDescriptions.statusNext.name : 'Validar usuario'
                let nameBackBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusBack && workflowExecution.data.workflowStatusDescriptions.statusBack.name) ? workflowExecution.data.workflowStatusDescriptions.statusBack.name : 'Regresar'

                //status cancel
                let cancelBtnName = (workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel && workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.label) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.label : ''
                let statusCancel = (workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel && workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.status) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.status : ''
                let showBtnCancelStatus = (cancelBtnName && statusCancel) ? true : false

                //verify if user has permission
                let rolesMember = workflowExecution.data.workflowExecutionMembers.filter((member) => member.email === user.userMetaData.userA3Cloud.email)
                let userPermissionWorkflowArr = JSON.parse(workflowExecution.data.workflowStatus.membersTypeAllowToShow)
                let allPermission = rolesMember.map(role => {
                    let permissionUser = userPermissionWorkflowArr.includes(role.workflowExecutionMemberTypeId)
                    return permissionUser
                })

                let userHasPermission = allPermission.includes(true) ? true : false
                let statusNextBtn = workflowExecution.data.workflowStatusDescriptions.statusNext.status
                let statusBackBtn = workflowExecution.data.workflowStatusDescriptions.statusBack.status
                let showBtnNextStatus = (!statusIsEnable || !userHasPermission || statusNextBtn <= 0) ? false : true
                let showBtnBackStatus = (!statusIsEnable || !userHasPermission || statusBackBtn <= 0) ? false : true

                let showInvitations = (statusCurrent === Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316110) || statusCurrent === Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316130) || statusCurrent === Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316140)) ? true : false
                let showBtnAddGuest = (statusCurrent === Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316110)) ? true : false
                let showBtnToManageAssembly = (statusCurrent === Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316140)) ? true : false

                setTitleHeader(titleHeader)
                setWorkflow(workflowExecution.data)
                setStatusWorkflow(statusCurrent)
                setShowBtnNextStatus(showBtnNextStatus)
                setShowBtnBackStatus(showBtnBackStatus)
                setShowBtnCancelStatus(showBtnCancelStatus)
                setNameBtnNext(nameBtn)
                setNameBackBtn(nameBackBtn)
                setCancelBtnName(cancelBtnName)
                setUserHasPermission(userHasPermission)
                setShowInvitations(showInvitations)
                setShowBtnAddguest(showBtnAddGuest)
                setStatusCancel(statusCancel)
                setShowBtnToManageAssembly(showBtnToManageAssembly)
            } else {
                setIsLoading(false)
                toggleErrorRequesting(errorMessage, 4000, false, "/")
            }
        } catch (error) {
            setIsLoading(false)
            toggleErrorRequesting(errorMessage, 4000, false, "/")
        }
    }



    const getMessages = async () => {
        let errorMessages = "Ocurrió un error al consultar los mensajes";
        let userChat = {};
        try {
            //Get message and members chat
            let workflowMessage = await workflowMessagesService.getWorkFlowExecutionMessage(
                workflowExecutionId,
                timezone,
                token
            );
            if (
                workflowMessage &&
                workflowMessage.data &&
                Number(workflowMessage.statusCode) === 200
            ) {
                //Filter out duplicated members
                let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
                    workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
                );
                //users chat
                membersChat.map((member) => {
                    member.id = member.workflowExecutionMemberId;
                    member.avatarUrl = member.profilePicture;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarAltText = member.firstName + " " + member.firstLastName;
                    if (user.userMetaData.userA3Cloud.email === member.email) {
                        idAuthorMessage = member.id;
                        userChat = member;
                    }
                    return membersChat;
                });

                //Message chat
                workflowMessage.data.workflowExecutionMessages.map((member) => {
                    member.author = {
                        name: member.firstName + " " + member.firstLastName,
                        id: member.workflowExecutionMemberId,
                        avatarUrl: member.profilePicture,
                    };
                    let dateConvert = new Date(member.createdDate)
                    member.timestamp = dateConvert
                    member.text = member.workflowExecutionMemberMessage;
                    member.id = member.workflowExecutionMemberId;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarUrl = member.profilePicture;
                    if (member.workflowExecutionMemberMessageDoc.length > 0) {
                        member.attachments = [
                            {
                                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
                            },
                        ];
                    }
                    return workflowMessage.data.workflowExecutionMessages;
                });

                setMembersChat(membersChat)
                setConversation(workflowMessage.data.workflowExecutionMessages)
                setUsersChat(userChat)

            } else {
                setIsLoading(false)
                toggleErrorRequesting(errorMessages, 4000, false, "/")
            }
        } catch (error) {
            setIsLoading(false)
            toggleErrorRequesting(errorMessages, 4000, false, "/")
        }
    };

    const createMessage = async (messagesChat, fileContent) => {
        let data = new FormData();
        data.append("workflowExecutionId", workflowExecutionId);
        data.append("workflowExecutionMemberId", idAuthorMessage);
        data.append("message", messagesChat.text);
        data.append("documento", fileContent);
        data.append("timezone", timezone)

        await workflowMessagesService.createWorkflowExecutionNewMessage(data, token);
    };

    const markChatAsRead = async () => {
        try {
            await workflowMessagesService.markAsRead(workflowExecutionId, token)
        } catch (e) { }
    };

    const addNewMessageSocket = (message) => {
        let copyConversation = [...conversation];
        let indexMessage = copyConversation.length;
        let newMessage = {
            author: {
                name: `${message.firstName} ${message.firstLastName}`,
                id: Number(message.workflowExecutionMemberId),
                avatarUrl: message.profilePicture,
            },
            timestamp: message.workflowExcecutionMemberMessage
                ? new Date(message.workflowExcecutionMemberMessage.createdDate)
                : new Date(
                    message.workflowExecutionMemberMessageDocName[0].createdDate
                ),
            text: message.workflowExcecutionMemberMessage.message,
            id: Number(message.workflowExecutionMemberId),
            name: `${message.firstName} ${message.firstLastName}`,
            avatarUrl: message.profilePicture,
            workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
            workflowExecutionMemberMessage:
                message.workflowExcecutionMemberMessage.message === "" ||
                    message.workflowExcecutionMemberMessage.message === "undefined"
                    ? null
                    : message.workflowExcecutionMemberMessage.message,

            email: message.email,
            firstName: message.firstName,
            firstLastName: message.firstLastName,
            profilePicture: message.profilePicture,
            selectionIndex: indexMessage,
        };
        if (message.workflowExecutionMemberMessageDocName.length > 0) {
            newMessage.workflowExecutionMemberMessageDoc = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
            newMessage.attachments = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
        }

        copyConversation.push(newMessage);
        setConversation(copyConversation)
    };

    const handleInputChangeChat = async (e) => {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        setFileChat(file)
    }

    const changeStatusWorkflow = async (params) => {
        toggleLoadingRequesting(true)
        let ENV = process.env
        let messageError = t("assembliesDetailAction.errors.workflow.change")
        let assemblyData = {
            assemblyId: assembly.id,
            workflowExecutionId: workflow.workflowExecution.id,
            action: params.action,
        }

        if (statusWorkflow === Number(ENV.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316110) && params && params.action === 'next') {
            assemblyData = {
                ...assemblyData,
                extraParams: {
                    invitations: guests
                }
            }
        }

        if (params && params.action === 'defined') {
            assemblyData = {
                ...assemblyData,
                statusUpdate: statusCancel || Number(ENV.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316299)
            }
        }

        try {
            let workflow = await AssembliesService.changeStatusWorkflowAssembly(assemblyData, token)
            if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
                toggleLoadingRequesting(false)
                toggleCompletedRequesting(4000, true, "/")
            } else if (workflow && workflow.data && Number(workflow.statusCode) === 403) {
                messageError = t("ssembliesDetailAction.errors.workflow.change.data.not.found")
                throw new Error(messageError)
            } else if (workflow && workflow.data && Number(workflow.statusCode) === 430) {
                messageError = t("ssembliesDetailAction.errors.workflow.change.data.not.found")
                throw new Error(messageError)
            } else if (workflow && workflow.data && Number(workflow.statusCode) === 440) {
                messageError = t("assembliesDetailAction.errors.workflow.change.invitations")
                throw new Error(messageError)
            } else {
                throw new Error(messageError)
            }
        } catch (error) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    const sendManageAssembly = () => {
        history.push({ pathname: `/manage-assembly/${assembly.id}/${workflow.workflowExecution.id}` })
    }

    const updateAttendanceGuestAssembly = async (invitationId, attendance) => {
        let messageError = t("assembliesDetailAction.errors.update.attendance")

        try {
            let invitationData = {
                invitationId,
                attendance
            }
            let attendanceUpdated = await AssembliesService.updateAttendanceGuest(invitationData, token)
            if (attendanceUpdated && attendanceUpdated.data && Number(attendanceUpdated.statusCode) === 200) {

            } else if (attendanceUpdated && attendanceUpdated.data && Number(attendanceUpdated.statusCode) === 410) {
                messageError = t("assembliesDetailAction.errors.attendance.guest")
                throw new Error(messageError)
            } else if (attendanceUpdated && attendanceUpdated.data && Number(attendanceUpdated.statusCode) === 430) {
                messageError = t("assembliesDetailAction.errors.attendance.assembly")
                throw new Error(messageError)
            } else {
                throw new Error(messageError)
            }
        } catch (error) {
            toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    return (
        <>
            {statusWorkflow === 316160
                ? (<ManageAssemblyAction
                    statusWorkflow={statusWorkflow}
                    title={titleHeader}
                />)
                : <Grid
                    className="standard-wrapper"
                >
                    <AssembliesDetailView
                        isLoading={isLoading}
                        user={user}
                        titleHeader={titleHeader}
                        showLoadingRequesting={showLoadingRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        showErrorRequesting={showErrorRequesting}
                        messageComplete={messageComplete}
                        messageError={messageError}
                        toggleErrorRequestingFalse={toggleErrorRequestingFalse}
                        toggleErrorRequesting={toggleErrorRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        membersChat={membersChat}
                        usersChat={usersChat}
                        conversation={conversation}
                        createMessage={createMessage}
                        markChatAsRead={markChatAsRead}
                        handleInputChangeChat={handleInputChangeChat}
                        assembly={assembly}
                        workflow={workflow}
                        statusWorkflow={statusWorkflow}
                        showBtnNextStatus={showBtnNextStatus}
                        showBtnBackStatus={showBtnBackStatus}
                        nameBtnNext={nameBtnNext}
                        backBtnName={backBtnName}
                        userHasPermission={userHasPermission}
                        cancelBtnName={cancelBtnName}
                        showBtnCancelStatus={showBtnCancelStatus}
                        showInvitations={showInvitations}
                        showChat={showChat}
                        showPdf={showPdf}
                        guests={guests}
                        showBtnAddGuest={showBtnAddGuest}
                        setGuests={setGuests}
                        changeStatusWorkflow={changeStatusWorkflow}
                        showBtnToManageAssembly={showBtnToManageAssembly}
                        sendManageAssembly={sendManageAssembly}
                        updateAttendanceGuestAssembly={updateAttendanceGuestAssembly}
                    />
                </Grid>
            }
        </>
    )
}

export default AssembliesDetailAction